import { Badge, BadgeProps } from '@chakra-ui/react'

type Props = BadgeProps
export const OptionalBadge: React.FC<Props> = ({ ...props }) => {
  return (
    <Badge
      py="0.5"
      px="1.5"
      bgColor="yellow.500"
      color="white"
      fontSize="10px"
      {...props}
    >
      任意
    </Badge>
  )
}
